// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_dompurify_dist_purify_es_mjs":"64d371be639adecc","node_modules_canvg_lib_index_es_js":"b10ea1a83ebb9bbd"}[chunkId] + ".js";
};